export const ELEMENT_WRAPPER_MB = "mb-6";
